module.exports = __webpack_public_path__ + "img/call.895c55ab.png";